import React, { Component } from 'react';
import PropTypes from 'prop-types';

import debounce from 'lodash.debounce';
import uuidv4 from 'uuid/v4';

import { RED } from 'screens/shared';

class Idle extends Component {
  constructor() {
    super();

    this.state = {
      currentScreen: 0
    };

    this.showRED = debounce(this.showRED, 500);
    this.showMainEngineNotStarted = debounce(this.showMainEngineNotStarted, 2000);
    this.showMainEngineStarted = debounce(this.showMainEngineStarted, 2000);
  }

  componentDidMount() {
    this.showRED();
  }

  showRED = () => {
    this.renderStep();
    this.showMainEngineNotStarted();
  }

  showMainEngineNotStarted = () => {
    this.renderStep();
    this.showMainEngineStarted();
  }

  showMainEngineStarted = () => {
    this.renderStep();
  }

  renderStep = () => {
    const currentScreen = this.state.currentScreen + 1;
    this.setState({ currentScreen });
  }

  render() {
    const [MainEngineNotStarted, MainEngineStarted] = this.props.components;

    const components = [
      <RED key={uuidv4()} src="" />,
      <RED key={uuidv4()} src="icon-xm-red" />,
      <MainEngineNotStarted key={uuidv4()} />,
      <MainEngineStarted key={uuidv4()} />
    ];

    return components[this.state.currentScreen];
  }
}

Idle.propTypes = {
  components: PropTypes.arrayOf(PropTypes.func).isRequired
};

export default Idle;



// WEBPACK FOOTER //
// ./src/screens/shared/Idle/Idle.js